import React, {ReactNode} from 'react';
import useClickOutside from "@Features/clickOutsideAwareComponent/hooks/useClickOutside";

interface ClickOutsideAwareComponentProps {
    className?: string,
    children: ReactNode,
    onClickOutside: (any?) => any,
}

function ClickOutsideAwareComponent({children, onClickOutside, className}: ClickOutsideAwareComponentProps) {
    const ref = useClickOutside(onClickOutside)

    return (
        <div ref={ref} className={className}>
            {children}
        </div>
    );
}

export default ClickOutsideAwareComponent;